export const SET_SETTING_CONFIG = 'SET_SETTING_CONFIG'



// WEBPACK FOOTER //
// ./src/types/shopSetting.js